import axios from 'axios'
import moment from 'moment'
import store from '../../../store'

const setList = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/procedure/done/value`, {
      params: {
        customer: store.state.customer,
        doctor: store.state.auth.auth.user.crm,
        periodStart: moment().add('months', -2).date(0).format('MM-DD-YYYY'),
        periodEnd: moment().add('months', 2).date(0).format('MM-DD-YYYY')
      }
    })
      .then(function (response) {
        // handle success
        const items = response.data.results.results.map((item) => {
          return {
            mount: item.tbQtde,
            value: item.tbValor,
            covenant: item.tbConvenio,
            doctor: item.tbMedico,
            crm: item.tbCRM
          }
        })
        resolve(commit('SET_LIST', items))
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setAvailableAppointments = ({ commit }, schedule) => {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/procedure/done/amount`, {
      params: {
        customer: store.state.customer,
        doctor: store.state.auth.auth.user.crm,
        periodStart: moment().add('months', -2).date(0).format('MM-DD-YYYY'),
        periodEnd: moment().add('months', 2).date(0).format('MM-DD-YYYY')
      }
    })
      .then(function (response) {
        // handle success
        const items = response.data.results.results.map((item) => {
          return {
            amount: item.tbQtde,
            month: item.tbMes,
            year: item.tbAno
          }
        })
        resolve(commit('SET_AVAILABLEAPPOINTMENTS', items))
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

export default {
  setList,
  setAvailableAppointments
}



// WEBPACK FOOTER //
// ./src/store/modules/proced/actions.js